// ################################
// !!!! Begin camargue sliders

function camargueSliders() {
    let camargueSplides = document.querySelectorAll(".splide.camargue-slider");
    for (
      let i = 0, splideLength = camargueSplides.length;
      i < splideLength;
      i++
    ) {
      new Splide(camargueSplides[i], {
        // Desktop on down
        perPage: 1.5,
        perMove: 1,
        focus: 0, // 0 = left and 'center' = center
        type: "slide", // 'loop' or 'slide'
        gap: "2.93em", // space between slides
        arrows: "slider", // 'slider' or false
        drag: false,
        pagination: false, // 'slider' or false
        speed: 1300, // transition speed in miliseconds
        easing: "cubic-bezier(.645, .045, .355, 1)",
        dragAngleThreshold: 30, // default is 30
        waitForTransition: false,
        updateOnMove: true,
        trimSpace: false, // true removes empty space from end of list
        flickPower: 200,
        flickMaxPages: 1,
        dragMinThreshold: 70,
        breakpoints: {
          991: {
            // Tablet
            drag: true
          },
          767: {
            // Mobile Landscape
            drag: true
          },
          479: {
            // Mobile Portrait
            drag: true
          }
        }
      }).mount();
    }
  }
  
  camargueSliders();
  
  // !!!! End camargue sliders
  // ################################